import React, { Fragment } from "react";
import { Route } from "react-router-dom";
import NavBar from "../components/Layout/NavBar/NavBar";
import LaunchBanner from "../components/LaunchBanner/LaunchBanner";
import ScrollToTop from "../utils/ScrollToTop";
import PopUpDialog from "../components/PopUpDialog/PopUpDialog";
import CookiesConsent from "../components/CookiesConsent/CookiesConsent";
import Footer from "../components/Layout/Footer/Footer";

export default function RouteWithNavElements({
  exact,
  path,
  component: Component,
  ...rest
}) {
  return (
    <Route
      exact={exact}
      path={path}
      {...rest}
      render={(routeProps) => {
        return (
          <Fragment>
            <NavBar />
            <LaunchBanner />
            <div className="content">
              <ScrollToTop />
              <Component {...routeProps} />
            </div>
            <Footer />
            {/* <PopUpDialog /> */}
            {/* <CookiesConsent /> */}
          </Fragment>
        );
      }}
    />
  );
}
